const isProduction = process.env.NODE_ENV === "production";

import("libs/clickoutside").then(async (module) => {
	const navigation = (await import("components/main-navigation")).default;
	return module.default(() => {
		if (navigation.el.root.classList.contains("open")) {
			navigation.reset();
		}
	});
});

document.addEventListener("DOMContentLoaded", () => {
	import("focus-visible").then((module) => module);
	import("utility/prefetch").then((module) => module.default.init());
	// RMOVE THIS WHEN YOU START THE PROJECT
	if (document.querySelectorAll<HTMLElement>(".body")) {
		import("components/tester").then((module) => module.default.init());
	}

	// Accessibility for checkbox hack (pretty-check)
	if (document.querySelector<HTMLElement>(".pretty-check")) {
		import("components/pretty-check").then((module) => module.default.init());
	}

	if (!isProduction) {
		if (document.querySelector<HTMLElement>(".overlay-grid")) {
			import("helpers/overlay-grid").then((module) => module.default.init());
		}
	}

	if (document.querySelector<HTMLElement>(".header-mobile")) {
		import("components/mobile-navigation").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector<HTMLElement>(".header")) {
		import("components/main-navigation").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector<HTMLElement>(".accordion")) {
		import("components/accordion").then((module) => module.default.init());
	}

	if (document.querySelector("[data-action='redirect']")) {
		import("components/redirect").then((module) => module.default.init());
	}

	if (document.querySelector<HTMLElement>(".map-block")) {
		import("blocks/sgs-stats-map-block").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector(".article__related")) {
		import("components/related-articles").then((module) =>
			module.default.init(),
		);
	}

	if (document.querySelector("table")) {
		import("blocks/sgs-table-block").then((module) => module.default.init());
	}

	if (document.querySelector<HTMLElement>(".pdf-block[data-pdf-url]")) {
		import("blocks/sgs-pdf-block").then((module) => module.default.init());
	}

	if (document.querySelector<HTMLElement>(".youtube-block")) {
		import("blocks/sgs-youtube-block").then((module) => module.default.init());
	}

	if (document.querySelector<HTMLElement>(".youtube-content")) {
		import("./features/youtube-content").then((module) =>
			module.default.init(),
		);
	}

	setTimeout(() => {
		document.querySelector(".body").classList.remove("preload");
	}, 200);
});
